import Net from '../core/libs/Net';
import filter from 'lodash/filter';
import map from 'lodash/map';
import property from 'lodash/property';

import {
  TAppHomePageModule,
  TAppMergeSuggestion,
  TFetchHomepageDataRequest,
  TFetchHomepageDataResponse
} from 'TProtocol/homepage/messages';
import { TAuthHeader } from 'TProtocol/common/models';

export const fetchHomepageData = (authHeader: TAuthHeader): Promise<TFetchHomepageDataResponse> => {
  const componentFlagSet: Set<TAppHomePageModule> = new Set();
  componentFlagSet.add(TAppHomePageModule.MERGE_CONFIRMATION);
  const request = new TFetchHomepageDataRequest({
    timezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
    componentFlags: componentFlagSet
  });

  const client = Net.createHomepageService();
  return client.fetchHomepageData(authHeader, request);
};

export const getMergeSuggestions = (response: TFetchHomepageDataResponse): TAppMergeSuggestion[] => {
  const dataOfType = filter(response.sortedModules, { moduleType: TAppHomePageModule.MERGE_CONFIRMATION });
  const modules = map(dataOfType, property('data'));
  return map(modules, property('mergeSuggestionData')) as TAppMergeSuggestion[];
};
